import { jsx as _jsx } from "react/jsx-runtime";
import { SDUIComponentRenderer } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/SDUIComponentRenderer/SDUIComponentRenderer";
import { SDUISectionStyleWrapper } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/SDUISectionRenderer/SDUISectionStyleWrapper/SDUISectionStyleWrapper";
import { SDUILayoutRenderer } from "@faire/retailer-visitor-shared/components/SDUI/LayoutRenderers/SDUILayoutRenderer";
import React from "react";
export var SDUILayoutSectionRenderer = function(param) {
    var section = param.section, componentRenderers = param.componentRenderers, sectionLoggingData = param.sectionLoggingData;
    var layoutSection = section.layout_section;
    var components = layoutSection === null || layoutSection === void 0 ? void 0 : layoutSection.components;
    if (!components || components.length === 0) {
        return null;
    }
    var layoutItems = getLayoutItems(components, componentRenderers, sectionLoggingData);
    var layoutSectionVisibility = getSectionVisibility(section);
    return /*#__PURE__*/ _jsx(SDUISectionStyleWrapper, {
        sectionStyles: section.style,
        sectionVisibility: layoutSectionVisibility,
        children: /*#__PURE__*/ _jsx(SDUILayoutRenderer, {
            items: layoutItems,
            layout: layoutSection === null || layoutSection === void 0 ? void 0 : layoutSection.layout
        })
    });
};
var getLayoutItems = function(components, componentRenderers, sectionLoggingData) {
    return components.map(function(component, idx) {
        var _component_id;
        var itemKey = ((_component_id = component.id) !== null && _component_id !== void 0 ? _component_id : "") + idx;
        var isPrimaryContent = component.is_required_for_interactivity === true;
        return {
            item: /*#__PURE__*/ _jsx(SDUIComponentRenderer, {
                component: component,
                componentRenderers: componentRenderers,
                sectionLoggingParams: sectionLoggingData,
                isPrimaryContent: isPrimaryContent
            }, itemKey),
            itemKey: itemKey,
            itemVisibility: component.viewports
        };
    });
};
var getSectionVisibility = function(section) {
    var _section_layout_section_layout_flow_layout, _section_layout_section_layout, _section_layout_section;
    var componentWidths = (_section_layout_section = section.layout_section) === null || _section_layout_section === void 0 ? void 0 : (_section_layout_section_layout = _section_layout_section.layout) === null || _section_layout_section_layout === void 0 ? void 0 : (_section_layout_section_layout_flow_layout = _section_layout_section_layout.flow_layout) === null || _section_layout_section_layout_flow_layout === void 0 ? void 0 : _section_layout_section_layout_flow_layout.component_widths;
    if (!componentWidths) {
        return undefined;
    }
    return {
        mobileAndAbove: componentWidths.mobile_and_above.length > 0,
        tabletAndAbove: componentWidths.tablet_and_above.length > 0,
        desktopAndAbove: componentWidths.desktop_and_above.length > 0
    };
};
